//var baseUrl ="https://4ce5-2607-fea8-b5d-bc20-2806-70fa-e730-4829.ngrok-free.app";
var baseUrl = "https://powerful-forest-56212-f200533330ed.herokuapp.com";

export default baseUrl;
